import React from "react";

import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import useResponsiveFlags from "../../hooks/useResponsiveFlags";

export default function JobTableHead(props) {
  const { order, orderBy, onSort } = props;
  const { isSmallMobileScreen } = useResponsiveFlags();
  return (
    <TableHead>
      <TableRow>
        <TableCell
          style={
            !isSmallMobileScreen
              ? {
                  position: "sticky",
                  top: 0,
                  left: 0,
                  zIndex: 11,
                }
              : {}
          }
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span className="storage-limit" style={{ marginRight: "8px" }}>
              Job ID
            </span>
            <SortingIcon
              order={order}
              active={orderBy === "id"}
              onClick={() => onSort("id")}
            />
          </div>
        </TableCell>
        
        <TableCell style={{ minWidth: "126.5px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span className="storage-limit" style={{ marginRight: "8px" }}>
              User
            </span>

            <SortingIcon
              order={order}
              active={orderBy === "user_email"}
              onClick={() => onSort("user_email")}
            />
          </div>
        </TableCell>
        <TableCell>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span className="storage-limit" style={{ marginRight: "8px" }}>
              Org
            </span>
            <SortingIcon
              order={order}
              active={orderBy === "org_name"}
              onClick={() => onSort("org_name")}
            />
          </div>
        </TableCell>
        <TableCell style={{ minWidth: "134px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span className="storage-limit" style={{ marginRight: "8px" }}>
              Token ID
            </span>

            <SortingIcon
              order={order}
              active={orderBy === "tokenid"}
              onClick={() => onSort("tokenid")}
            />
          </div>
        </TableCell>
        <TableCell style={{ minWidth: "109.5px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span className="storage-limit" style={{ marginRight: "8px" }}>
              Type
            </span>

            <SortingIcon
              order={order}
              active={orderBy === "runtype"}
              onClick={() => onSort("runtype")}
            />
          </div>
        </TableCell>
        <TableCell>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span className="storage-limit" style={{ marginRight: "8px" }}>
              File ID
            </span>
          </div>
        </TableCell>
        <TableCell style={{ minWidth: "97px" }}>
          <span className="storage-limit" style={{ marginRight: "8px" }}>
            Job Description
          </span>
        </TableCell>
        
        <TableCell style={{ minWidth: "109.5px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span className="storage-limit" style={{ marginRight: "8px" }}>
              Status
            </span>
          </div>
        </TableCell>
        <TableCell>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span className="storage-limit" style={{ marginRight: "8px" }}>
              Date
            </span>
            <SortingIcon
              order={order}
              active={orderBy === "date"}
              onClick={() => onSort("date")}
            />
          </div>
        </TableCell>

        <TableCell style={{ minWidth: "109.5px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span className="storage-limit" style={{ marginRight: "8px" }}>
              Sequence Type
            </span>

            <SortingIcon
              order={order}
              active={orderBy === "sequencetype"}
              onClick={() => onSort("sequencetype")}
            />
          </div>
        </TableCell>
        
      </TableRow>
    </TableHead>
  );
}

function SortingIcon({ order, active, onClick }) {
  return (
    <span
      onClick={onClick}
      style={{
        cursor: "pointer",
        display: "inline-flex",
        flexDirection: "column",
        //   alignItems: "center",
        //   marginLeft: "5px",
      }}
    >
      <span
        style={{
          color: active && order === "asc" ? "#000" : "#ccc",
          fontSize: "0.5rem",
          lineHeight: "0.5rem",
        }}
      >
        ▲
      </span>
      <span
        style={{
          color: active && order === "desc" ? "#000" : "#ccc",
          fontSize: "0.5rem",
          lineHeight: "0.5rem",
        }}
      >
        ▼
      </span>
    </span>
  );
}
